import { createStyles, getStylesRef } from '@mantine/core';
import { IconButton, ListBox } from '@repo/foundations';
import { GlossarySynonymPill } from './GlossarySynonymPill';

const useStyles = createStyles((theme) => ({
	menuItem: {
		flexWrap: 'nowrap',
		maxWidth: theme.other.width.md,

		[`&:hover .${getStylesRef('rightSection')}`]: {
			opacity: 1,
		},
	},
	label: {
		overflowWrap: 'anywhere',
	},
	rightSection: {
		ref: getStylesRef('rightSection'),
		opacity: 0,
		marginLeft: theme.spacing.xs,
	},
}));

interface IGlossarySynonymItemProps {
	synonym: string;
	onRemove?: () => Promise<void>;
	getProps: (
		userProps: Omit<React.HTMLProps<HTMLElement>, 'ref'>
	) => Omit<React.HTMLProps<HTMLElement>, 'ref'>;
}

export function GlossarySynonymItem({
	synonym,
	onRemove,
	getProps,
}: IGlossarySynonymItemProps) {
	const { classes } = useStyles();

	const handleOnClick = () => {
		// For synonyms, we don't navigate anywhere, just handle the click
		// This could be used for future functionality like highlighting the synonym
	};

	return (
		<ListBox.Item
			{...getProps({
				onClick: handleOnClick,
				className: classes.menuItem,
			})}
			rightSection={
				onRemove && (
					<IconButton
						className={classes.rightSection}
						iconName="x"
						variant="tertiary"
						onClick={async (event) => {
							event.stopPropagation();
							await onRemove();
						}}
						tooltip="Remove synonym"
					/>
				)
			}
		>
			<GlossarySynonymPill synonym={synonym} />
		</ListBox.Item>
	);
}
